import axios from "axios";

// Same-origin only. The frontend ALWAYS talks to the backend on the same host
// it was served from (relative "/api"). This eliminates cross-origin issues on
// custom domains (landho.com.ar), the Emergent deployment host
// (admin-cordoba.emergent.host), and the preview host — because in every
// deployed target, the backend is exposed under /api of the same host via the
// k8s ingress. Do NOT fall back to REACT_APP_BACKEND_URL: an absolute URL to a
// different host reintroduces the CORS/cookie failure that this fix removes.
export const API = "/api";

const TOKEN_KEY = "session_token";

export const getStoredToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch { return ""; }
};
export const setStoredToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (e) { console.error("localStorage setStoredToken falló (quota / privacy mode)", e); }
};

const api = axios.create({
  baseURL: API,
  // withCredentials must stay OFF: the preview ingress rewrites the response
  // header to `Access-Control-Allow-Origin: *` which — per CORS spec — forces
  // the browser to DROP the entire response body when `withCredentials: true`.
  // We already use Bearer/localStorage tokens (see interceptor below), so we
  // don't need cookies at all.
  withCredentials: false,
});

// Attach the stored session_token on every request as a Bearer header.
// The backend already accepts either cookie or Authorization header (see auth.py
// extract_session_token). This is the resilient path when the cross-origin
// Set-Cookie gets dropped by the preview ingress.
api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization && !config.headers.authorization) {
      config.headers.Authorization = `Bearer ${t}`;
    }
  }
  return config;
});

export default api;

// Same-origin file URL — relative path, browser resolves against current host.
export const fileUrl = (relPath) => {
  if (!relPath) return "";
  return relPath;
};
